module.exports = __webpack_public_path__ + "static/media/green.a5f5af9d.png";